import { NgModule } from '@angular/core';

import { ErpPersonService } from './service/erp-person-service';

/**
 * CoreModule for jobapplications.
 */
@NgModule( {
    imports: [
    ],
    declarations: [
    ],
    exports: [
    ],
    providers: [
        ErpPersonService
    ],
} )

export class PersonCoreModule {
}
